<mat-toolbar color="primary" class="top-bar" data-testid="top-toolbar">
  <button mat-icon-button data-testid="menu-toggle-button" (click)="menuClicked.emit()">
    <mat-icon>{{ menuOpen() ? 'menu_open' : 'menu' }}</mat-icon>
  </button>
  <span class="organization-name">{{userStore.currentOrganization()?.name}}</span>
  @if (isRTL()) {
    <span class="separator">\</span>
  } @else {
    <span class="separator">/</span>
  }
  <span class="page-title">{{ pageTitle }}</span>
  <span class="spacer"></span>
  
  <!-- User menu: shown whenever the session has a valid token (not only after /start loads profile) -->
  @if (authStore.isAuthenticated()) {
    <button
      mat-icon-button
      class="user-menu-button"
      data-testid="user-menu-button"
      [matMenuTriggerFor]="userMenu"
      [attr.aria-label]="'navigation.user-menu' | translate"
    >
      <mat-icon>person</mat-icon>
    </button>

    <mat-menu #userMenu="matMenu" class="user-menu">
      @if (currentUser(); as user) {
        <div class="user-info" mat-menu-item disabled>
          <div class="user-details">
            <span class="user-name">{{ user.name }}</span>
            <span class="user-email">{{ user.email }}</span>
          </div>
        </div>
        <mat-divider></mat-divider>
      }

      @if (currentUser()) {
        <button mat-menu-item data-testid="view-profile-button" (click)="onViewProfile()">
          <mat-icon>person</mat-icon>
          <span>{{ 'navigation.view-profile' | translate }}</span>
        </button>

        <button mat-menu-item data-testid="settings-button" (click)="onSettings()">
          <mat-icon>settings</mat-icon>
          <span>{{ 'navigation.settings' | translate }}</span>
        </button>

        <a mat-menu-item data-testid="help-button" routerLink="/help">
          <mat-icon>help_outline</mat-icon>
          <span>{{ 'navigation.help' | translate }}</span>
        </a>

        <mat-divider></mat-divider>

        <button mat-menu-item data-testid="switch-organization-button" (click)="onSwitchOrganization()">
          <mat-icon>switch_account</mat-icon>
          <span>{{ 'navigation.switch-organization' | translate }}</span>
        </button>

        <mat-divider></mat-divider>

        <div class="version-info" mat-menu-item disabled>
          <mat-icon>info</mat-icon>
          <span class="version-text">{{ 'navigation.app-version' | translate }}: v{{ appVersion }}</span>
        </div>

        <mat-divider></mat-divider>
      }

      <button
        mat-menu-item
        data-testid="sign-out-button"
        (click)="onSignOut()"
        class="sign-out-button"
      >
        <mat-icon>logout</mat-icon>
        <span>{{ 'navigation.sign-out' | translate }}</span>
      </button>
    </mat-menu>
  }
</mat-toolbar>
